export const DEFAULT_LANGUAGE = 'ro';
export const DEFAULT_PHONE_PREFIX = 'RO';
